import { skipToken, useQuery, type UseQueryResult } from '@tanstack/react-query'
import { signService } from '@/services/SignService'
import { signingKeys } from '@/hooks/queryKeys'
import type { SigningSessionDto } from '@lib/dto/signing-session.dto'

export function useSigningSession(
  token: string | undefined,
): UseQueryResult<SigningSessionDto> {
  return useQuery({
    queryKey: signingKeys.session(token),
    queryFn: token ? () => signService.getSession(token) : skipToken,
    retry: false,
  })
}
